import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  stroke: "currentColor",
  viewBox: "0 0 64 64"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      "stroke-width": "3",
      d: "M46 44a26 26 0 0 1-24.94-33.36 24 24 0 1 0 32.3 32.3A26.2 26.2 0 0 1 46 44z"
    }, null, -1)
  ])))
}
export default { render: render }